import {
	MimaButton,
	MimaDateFilter,
	MimaFilter,
	MimaText,
	PageLoader,
	MimaDropdownFilter,
	MimaTable,
} from '../../components';
import CreateSubwalletContainer from '../../containers/SubwalletContainer/CreateSubwalletContainer';
import { SubwalletInfoContainer, TransferContainer } from '../../containers';
import styles from '../../assets/styles/Subwallet/Subwallet.module.scss';
import { userStore, walletStore } from '../../stores';
import { amountFormatter } from '../../utils/utils';
import { AnimatePresence } from 'framer-motion';
import { AppPage } from '../../components';
import React, { useMemo, useState } from 'react';
import { SubBalanceCard } from '..';
import { Formik } from 'formik';
import moment from 'moment';
import { toJS } from 'mobx';
import Survey from '../../components/Survey/Survey';
import { downloadXlsx2 } from '../../utils/download';
import constant from '../../utils/constant';

const Subwallet = ({
	closeWalletModal,
	closeModal,
	transferModal,
	onSubmit,
	validationSchema,
	loading,
	transfer,
	refreshWallet,
	transferSwitchState,
	sharedState,
	refresh,
	filterPeriod,
	resetFilter,
	viewMore,
	showViewMore,
	createSubWallet,
	addWallet,
	getDate,
	filterPeriods,
	receiptDLHandler,
	loading2,
	needFeedback,
	data,
	isLoading,
	isFetching,
	onLimitChange,
	limit,
	currentPage,
	setCurrentPage,
	setSearchQuery,
}) => {
	const [onReset, setOnReset] = useState(false);
	const [showSurvey, setShowSurvey] = useState(false);

	const tableData = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data?.transactions || [];
		}
		return [];
	}, [data]);

	const tableColumns = [
		{
			Header: 'Created Date',
			accessor: 'createdAt',
			Cell: ({ cell }) => {
				const formattedDate = moment(cell.value).format('DD/MM/YY');
				return <span>{formattedDate}</span>;
			},
		},
		{
			Header: 'Employee',
			Cell: ({ cell }) => {
				const firstName = cell.row.original.user?.firstname;
				const lastName = cell.row.original.user?.lastname;

				return <span>{`${firstName} ${lastName}`}</span>;
			},
		},
		{
			Header: 'SubWallet',
			Cell: ({ cell }) => {
				const subWallet = cell.row.original.subWallet?.name;
				return <span>{subWallet}</span>;
			},
		},
		{
			Header: 'Category',
			accessor: 'name',
			Cell: ({ cell }) => {
				const category = cell.row.original?.expenseCategory?.name;
				return <span>{category}</span>;
			},
		},
		{
			Header: 'Bank',
			accessor: 'bankName',
			Cell: ({ cell }) => {
				const bank = cell.row.original?.bankName || '';
				return <span>{bank}</span>;
			},
		},
		{
			Header: 'Account Number',
			accessor: 'receiverAccountNumber',
			Cell: ({ cell }) => {
				const bank = cell.row.original?.receiverAccountNumber || '';
				return <span>{bank}</span>;
			},
		},
		{
			Header: 'Receiver Name',
			accessor: 'receiverAccountName',
			Cell: ({ cell }) => {
				const bank = cell.row.original?.receiverAccountName || '';
				return <span>{bank}</span>;
			},
		},
		{
			Header: 'Narration',
			accessor: 'narration',
		},
		{
			Header: 'Amount',
			accessor: 'amountPaid',
			Cell: ({ cell }) => {
				const amount = cell.value;
				const formattedAmount = amountFormatter().format(parseInt(amount));
				return <span>{formattedAmount}</span>;
			},
		},
		{
			Header: 'Paid Date',
			accessor: 'dueDate',
			Cell: ({ cell }) => {
				const dueDate = cell.row.original.dueDate;
				const formattedDate = moment(dueDate).format('DD/MM/YY hh:mm');
				return <span>{dueDate ? formattedDate : ''}</span>;
			},
		},
		{
			Header: 'Actions',
			Cell: ({ cell }) => {
				const item = cell.row.original;
				return (
					<MimaButton
						title="Get Receipt"
						variant="smaller"
						buttonColor="var(--color-green)"
						loading={loading2}
						onClick={() => {
							receiptDLHandler(item);
						}}
					/>
				);
			},
		},
	];

	const permissions = new Set(
		toJS(userStore.user?.permissions?.map(perm => perm.name))
	);

	const printData = tableData.map(transaction => ({
		'Created Date': moment(transaction.createdAt).format('DD-MM-YYYY hh:mm'),
		Employee: `${transaction?.user?.firstname} ${transaction?.user?.lastname}`,
		Subwallet: transaction?.subWallet?.name || '',
		Category: transaction?.expenseCategory?.name || '',
		Bank: transaction?.bankName || '',
		'Account Number': transaction?.receiverAccountNumber || '',
		'Receiver Name': transaction?.receiverAccountName || '',
		Narration: transaction?.narration || '',
		'Amount Paid': amountFormatter().format(parseInt(transaction?.amountPaid)),
		'Paid Date': transaction?.dueDate
			? moment(transaction?.dueDate).format('DD-MM-YYYY hh:mm')
			: '',
	}));

	return (
		<AppPage pageTitle="Petty Cash Manager" refresh={refresh}>
			{loading ? (
				<PageLoader title="While we set things up for you" loading={loading} />
			) : (
				<>
					<MimaText mb={2} align="center">
						You are viewing Wallet Activities for {filterPeriod}
					</MimaText>

					<Formik
						initialValues={{
							startDate: '',
							endDate: '',
							period: '',
							periodText: '',
						}}
						validationSchema={validationSchema}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<MimaFilter
								filterClick={() => {
									setOnReset(false);
									handleSubmit();
								}}
								loading={loading}
								resetClick={() => {
									setOnReset(true);
									resetFilter();
								}}>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<MimaDropdownFilter
										labelTitle="Filter period"
										placeholder="Select Period"
										variant="medium"
										name="period"
										data={filterPeriods}
										onChange={data => {
											const dates = getDate(data.key);
											setFieldValue('period', data.key);
											setFieldValue('startDate', dates.startDate);
											setFieldValue('endDate', dates.endDate);
											setFieldValue('periodText', data.value);
										}}
										error={errors.period}
										touched={touched.period}
									/>
									{values.period === 'custom' && (
										<div
											style={{
												display: 'flex',
												gap: '2rem',
												marginTop: '2rem',
											}}>
											<MimaDateFilter
												labelTitle="start date"
												name="startDate"
												value={!onReset ? values.startDate : ''}
												onChange={text => {
													setOnReset(false);
													setFieldValue('startDate', text);
												}}
												onBlur={handleBlur}
												width={18}
												touched={touched.startDate}
												error={errors.startDate}
											/>
											<MimaDateFilter
												labelTitle="End date"
												name="endDate"
												value={!onReset ? values.endDate : ''}
												onChange={text => {
													setOnReset(false);
													setFieldValue('endDate', text);
												}}
												onBlur={handleBlur}
												width={18}
												touched={touched.endDate}
												error={errors.endDate}
											/>
										</div>
									)}
								</div>
							</MimaFilter>
						)}
					</Formik>

					<div className={styles.subwallet__group}>
						{walletStore.subWallets.map(wallet => (
							<SubBalanceCard
								wallet={wallet}
								refresh={refreshWallet}
								loading={loading}
								transfer={transfer}
								showViewMore={showViewMore}
							/>
						))}
					</div>

					<MimaText mt={3} mb={3} variant="subtitle" align="center">
						Petty Cash Transactions
					</MimaText>

					<div className={styles.balance__btns}>
						{permissions.has('CAN CREATE/UPDATE PETTY CASH BALANCE') && (
							<MimaButton
								title="Create Wallet"
								variant="filter"
								onClick={() => addWallet()}
								buttonColor="var(--color-primary)"
								width={15}
							/>
						)}

						<MimaButton
							title="Refresh"
							variant="filter"
							onClick={() => refreshWallet()}
							width={10}
						/>

						<MimaButton
							title="Download Report"
							variant="filter"
							onClick={() => {
								downloadXlsx2(printData, `Petty Cash`);
							}}
							width={18}
						/>
					</div>

					<MimaTable
						tableData={tableData}
						tableColumns={tableColumns}
						searchPlaceholder="Search Invoices"
						searchVariant="wide"
						totalItems={data?.data?.totalCounts}
						onLimitChange={onLimitChange}
						isLoading={isLoading}
						isFetching={isFetching}
						limit={limit}
						currentPage={currentPage}
						setCurrentPage={setCurrentPage}
						setSearchQuery={setSearchQuery}
					/>
					{(transferModal || viewMore || createSubWallet || showSurvey) && (
						<div className="modal">
							<AnimatePresence>
								{transferModal && (
									<TransferContainer
										sharedState={sharedState}
										closeWalletModal={closeWalletModal}
										transferSwitchState={transferSwitchState}
										setShowSurvey={setShowSurvey}
										needFeedback={needFeedback}
									/>
								)}

								{viewMore && <SubwalletInfoContainer closeModal={closeModal} />}
								{createSubWallet && (
									<CreateSubwalletContainer
										closeModal={closeModal}
										setShowSurvey={setShowSurvey}
									/>
								)}
								{showSurvey && (
									<Survey
										title=""
										reviewId={userStore.reviewId}
										closeModal={() => {
											setShowSurvey(false);
										}}
									/>
								)}
							</AnimatePresence>
						</div>
					)}
				</>
			)}
		</AppPage>
	);
};

export default Subwallet;
